export default class Testimonial {
  avatar?: string

  constructor(public name: string, public profession: string, public description: string, public stars: number, options?: {avatar: string}) {
    if (this.stars < 0 || this.stars > 5) throw Error('The start should be between 0 and 5')
    this.avatar = options?.avatar
  }
}
